import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
} from "@material-tailwind/react";
import {
  CrossIcon,
  GetInTouchIcon,
  SuggestionIcon,
  RequestIcon,
} from "../../common/icons";
import { helpModalContent } from "../../content/course-detail-page";
import CustomButton from "../../components/button/Button";

const iconMap: { [key: string]: JSX.Element } = {
  suggestion: <SuggestionIcon />,
  getintouch: <GetInTouchIcon />,
  request: <RequestIcon />,
};
export interface HelpModalProps {
  open?: boolean;
  handleClose?: () => void;
  Text: string;
  icon: string;
  userName: string;
  className?: string;
}

const HelpModal: React.FC<HelpModalProps> = ({
  open: propOpen,
  handleClose: propHandleClose,
  Text,
  icon,
  className,
}) => {
  const [open, setOpen] = useState<boolean>(propOpen || false);

  const handleClose = () => {
    if (propHandleClose) {
      propHandleClose();
    } else {
      setOpen(false);
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      {!propOpen && (
        <CustomButton
          buttonText={Text}
          icon={iconMap[icon] || null}
          onClick={handleOpen}
          className={`${className} border  border-primary hover:bg-primary-100  text-primary justify-center  text-nowrap text-xs`}
        />
      )}
      <Dialog
        open={propOpen !== undefined ? propOpen : open}
        handler={handleClose}
        size="lg"
        className="pl-2 py-1"
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <DialogHeader className="flex justify-between items-center">
          <h3 className="text-lg font-bold text-black">
            {helpModalContent.header}
          </h3>
          <Button onClick={handleClose} variant="text" className="p-2">
            <CrossIcon className="w-6 h-6 text-body hover:text-title" />
          </Button>
        </DialogHeader>

        <DialogBody className="py-0 md:pr-0">
          <div className="flex flex-col md:flex-row gap-8">
            <div className="flex-1">
              <p className="text-sm text-body mb-1">
                {helpModalContent.description}
              </p>

              <div className="flex flex-col gap-4 mb-4">
                <div className="flex flex-row gap-4">
                  <input
                    type="text"
                    placeholder={helpModalContent.fields.lastName}
                    className="block w-full border text-sm border-line rounded-lg p-2 focus:border-primary focus:ring-primary"
                  />
                  <input
                    type="text"
                    placeholder={helpModalContent.fields.firstName}
                    className="block w-full border text-sm border-line rounded-lg p-2 focus:border-primary focus:ring-primary"
                  />
                </div>

                <div className="flex flex-row gap-4">
                  <input
                    type="email"
                    placeholder={helpModalContent.fields.email}
                    className="block w-full border text-sm border-line rounded-lg p-2 focus:border-primary focus:ring-primary"
                  />
                  <input
                    type="text"
                    placeholder={helpModalContent.fields.contactNumber}
                    className="block w-full border text-sm border-line rounded-lg p-2 focus:border-primary focus:ring-primary"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-title mb-1">
                    {helpModalContent.fields.subjectLabel}
                  </label>
                  <input
                    type="text"
                    className="block w-full border border-line rounded-lg p-2 focus:border-primary focus:ring-primary"
                  />
                </div>

                <div className="mb-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {helpModalContent.fields.messageLabel}
                  </label>
                  <textarea
                    rows={4}
                    placeholder={helpModalContent.fields.messagePlaceholder}
                    className="block w-full border text-sm border-line rounded-lg p-2 focus:border-primary focus:ring-primary"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-4 p-0">
                <button
                  onClick={handleClose}
                  className="px-9 py-2 rounded-full border border-primary text-primary hover:bg-primary-100"
                >
                  {helpModalContent.buttons.cancel}
                </button>
                <button className="px-12 py-2 rounded-full bg-primary text-white hover:bg-primary-800">
                  {helpModalContent.buttons.send}
                </button>
              </div>
            </div>

            <div className="relative sm:absolute md:relative flex items-center justify-center right-0 px-0 order-first md:order-1">
              <img
                src={helpModalContent.images.mobile}
                alt="Mobile Decorative"
                className="max-w-full h-auto object-contain w-[290px] md:hidden"
              />
              <img
                src={helpModalContent.images.desktop}
                alt="Desktop Decorative"
                className="max-w-full h-auto object-contain w-[290px] hidden md:block"
              />
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </>
  );
};

export default HelpModal;
